module.exports = __webpack_public_path__ + "static/media/social-yahoo.07fb9b39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-yahoo.svg
// module id = 86
// module chunks = 0